import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="container" style={{ padding: '60px 20px', textAlign: 'center' }}>
    <h1 style={{ marginBottom: '16px', color: 'var(--text-dark, #2d2d2d)' }}>Sivu ei löytynyt</h1>
    <p style={{ marginBottom: '24px', color: 'var(--text-gray, #666)' }}>
      Etsimääsi sivua ei ole olemassa.
    </p>
    <Link to="/" className="btn btn-primary">Etusivulle</Link>
  </div>
);

export default NotFound;
